import React, { createContext, useCallback, useContext } from 'react';
import { node, string } from 'prop-types';
import localeFunc from 'locale';
import dayjs from 'dayjs';

export const LocaleContext = createContext(null);
export const useLocaleContext = () => useContext(LocaleContext);

function LocaleProvider({ language, host, children }) {
  dayjs.locale('language');

  const locale = useCallback(
    (key, keyMap) => {
      return localeFunc(key, language, keyMap);
    },
    [language]
  );

  return (
    <LocaleContext.Provider value={{ locale, language, host }}>
      {children}
    </LocaleContext.Provider>
  );
}

LocaleProvider.propTypes = {
  language: string,
  children: node,
  host: string,
};

export default LocaleProvider;
